export const getCorrectedAspectRatioThumbnailURL = (
    urlString: string | undefined,
    width: number = 640
): string => {
    if (!urlString) return "";
    const hasParams = urlString.indexOf("?");

    return hasParams !== -1
        ? `${urlString}&width=${width}`
        : `${urlString}?width=${width}`;
};
